import { assetInfoText } from './assetInfoText';
import styles from './AssetInfoBox.module.css';
import { scriptAttrs } from '@/lib/scriptDetect';

/** Optional per-asset info callout shown at the top of the asset in the
 *  talent view. Renders nothing when there is no admin text. Text is
 *  rendered as a plain text node (no markdown/HTML) with line breaks
 *  preserved via CSS. */
export function AssetInfoBox({ text }: { text?: string | null }) {
  const value = assetInfoText(text);
  if (!value) return null;
  return (
    <div className={styles.box} role="note">
      <i className={`ph-bold ph-info ${styles.icon}`} aria-hidden="true" />
      <p className={styles.text} {...scriptAttrs(value)}>{value}</p>
    </div>
  );
}
